import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface AddUsersToDataAlertsParams {
  dataAlertIds: string[];
  userIds: string[];
}

export class AddUsersToDataAlertsRequest extends Request<AddUsersToDataAlertsParams, IResult> {
  constructor(params: AddUsersToDataAlertsParams) {
    super('addUsersToDataAlerts', params);
  }
}
